import React from "react";
import { Row, Col, Card, Statistic, Typography, Tag, Button, Space, Alert } from "antd";
import { useNavigate } from "react-router-dom";
import { useCurrentProject } from "../../hooks/useCurrentProject";
import { projectPath } from "../../config/nav";

const { Title, Text } = Typography;

const ProjectOverview: React.FC = () => {
  const navigate = useNavigate();
  const { project, projectKey, isPostchat } = useCurrentProject();

  if (!project || !projectKey) return null; // ProjectGuard 已处理加载/未找到态

  const go = (sub: string) => navigate(projectPath(projectKey, sub));
  const stats = project.stats;

  return (
    <div style={{ padding: 24, maxWidth: 1100, margin: "0 auto" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
        <Title level={4} style={{ margin: 0 }}>{project.name}</Title>
        <Tag color={isPostchat ? "blue" : "green"}>{isPostchat ? "全功能" : "仅摘要"}</Tag>
        <Text type="secondary" copyable={{ text: project.key_value }} style={{ fontSize: 12 }}>
          KEY: {project.key_value}
        </Text>
      </div>

      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col xs={12} md={6}><Card><Statistic title="摘要数" value={stats?.summary_count ?? 0} /></Card></Col>
        <Col xs={12} md={6}><Card><Statistic title="对话次数" value={stats?.use_count ?? 0} /></Card></Col>
        <Col xs={12} md={6}><Card><Statistic title="知识条目" value={stats?.knowledge_count ?? 0} /></Card></Col>
        <Col xs={12} md={6}><Card><Statistic title="已用 Token" value={stats?.token_used ?? 0} /></Card></Col>
      </Row>

      {!isPostchat && (
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
          message="这是「仅摘要」项目"
          description="升级 Pro 并改为全功能项目后，可使用知识库问答、智能体、站点操作与增长能力。"
          action={<Button size="small" type="primary" onClick={() => navigate("/payment-checkout?type=member")}>升级</Button>}
        />
      )}

      <Card title="快捷操作">
        <Space wrap>
          {isPostchat && <Button icon={<i className="ri-code-box-line" style={{ marginRight: 4 }} />} onClick={() => go("website")}>安装代码</Button>}
          {isPostchat && <Button icon={<i className="ri-robot-2-line" style={{ marginRight: 4 }} />} onClick={() => go("agents")}>智能体</Button>}
          {isPostchat && <Button icon={<i className="ri-book-2-line" style={{ marginRight: 4 }} />} onClick={() => go("knowledge")}>知识库</Button>}
          <Button icon={<i className="ri-file-text-line" style={{ marginRight: 4 }} />} onClick={() => go("summary-settings")}>摘要设置</Button>
          <Button icon={<i className="ri-line-chart-line" style={{ marginRight: 4 }} />} onClick={() => go("analytics")}>站点分析</Button>
        </Space>
      </Card>
    </div>
  );
};

export default ProjectOverview;
